import React, { ButtonHTMLAttributes } from 'react';
import styles from './ButtonLink.module.scss';

const ButtonLink = (props: ButtonHTMLAttributes<HTMLButtonElement>): JSX.Element => (
  <button type="button" {...props} className={`${styles.ButtonLink} Link LinkColorPrimary`} />
);

export default ButtonLink;
